export enum SignalREventType {
  AssignedTaskChanged = 'HousekeepingViews.AssignedTaskChanged',
  AttendantSheetChanged = 'HousekeepingViews.AttendantSheetChanged',
  HousekeepingRoomChanged = 'HousekeepingViews.HousekeepingRoomChanged',
  RoomMaintenanceChanged = 'HousekeepingViews.RoomMaintenanceChanged',
  RoomQueueChanged = 'HousekeepingViews.RoomQueueChanged'
}



// WEBPACK FOOTER //
// ./src/services/signalRClient/signalREventType.ts